<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Danh sách"
          :link="[
            { text: 'Cơ sở vật chất', href: '/facility' },
            { text: 'Quản lý Khu vực', href: '/facility/locations' }
          ]"
        />
      </div>
      <div class="flex-center">
        <v-btn depressed dark color="primary" @click="newDialog = !newDialog">
          <v-icon left>mdi-plus</v-icon> Thêm vị trí
        </v-btn>
      </div>
    </div>

    <div class="px-4">
      <v-card outlined class="pa-6 mb-6 elevation-0">
        <LocationFilter @onFilterChanged="onFilterChange" />
      </v-card>

      <v-card outlined class="elevation-0">
        <LocationDataTable ref="locationDataTable" />
      </v-card>
    </div>

    <LocationNewDialog :state="newDialog" @updated="onLocationUpdated" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import LocationDataTable from '@/modules/facility/location/LocationDataTable.vue'
import LocationFilter from '@/modules/facility/location/LocationFilter.vue'

export default {
  name: 'FacilityLocations',
  components: {
    Breadcrumbs,
    LocationDataTable,
    LocationFilter,
    LocationNewDialog: () => import('@/modules/facility/location/LocationNewDialog.vue')
  },
  data() {
    return {
      newDialog: false,
      currentFilter: {}
    }
  },
  methods: {
    onFilterChange(query) {
      this.currentFilter = query || {}
      this.$refs.locationDataTable.refresh(this.currentFilter)
    },
    onLocationUpdated() {
      this.$refs.locationDataTable.refresh(this.currentFilter)
    }
  }
}
</script>
